import { ImageLoadingStrategy, MediaConfig } from '@spartacus/storefront';
const mediaConfig: MediaConfig = {
  imageLoadingStrategy: ImageLoadingStrategy.LAZY,
};

export { mediaConfig };
